import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// import { VTimePicker } from 'vuetify/labs/VTimePicker'
// import { VNumberInput } from 'vuetify/labs/VNumberInput'
import { VDateInput, VStepperVertical, VStepperVerticalActions, VStepperVerticalItem, VFileUpload } from 'vuetify/lib/labs/components.mjs'
import { VColorInput } from 'vuetify/labs/VColorInput'
import { pt } from 'vuetify/locale'

export const vuetify = createVuetify({
  components: {
    ...components,
    // VTimePicker,
    // VNumberInput,
    VDateInput,
    VStepperVertical,
    VStepperVerticalItem,
    VStepperVerticalActions,
    VFileUpload,
    VColorInput
  },
  directives,
  icons: {
    defaultSet: 'mdi', // This is already the default value - only for display purposes
  },
  locale: {
    locale: 'pt',
    messages: {
      pt
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          'on-background': '#000000', // Define o valor de --v-theme-on-background
        },
      },
    },
  }
})
